import React, { useState, useEffect } from 'react';
import BackButtonBottom from '../../components/common/BackButtonBottom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getDriverBookings } from '../../services/bookingService';

// ═══════════════ DRIVER SCHEDULE ═══════════════
export default function DriverSchedule() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userProfile) return;
    setLoading(true);
    getDriverBookings(userProfile.id, 'confirmed').then((data) => {
      setBookings(data);
      setLoading(false);
    });
  }, [userProfile]);

  const todayBookings = bookings.filter((b) => {
    const bDate = b.scheduledPickupTime?.toDate ? new Date(b.scheduledPickupTime.toDate()).toISOString().split('T')[0] : '';
    return bDate === selectedDate;
  }).sort((a, b) => {
    const aTime = a.scheduledPickupTime?.toDate ? a.scheduledPickupTime.toDate().getTime() : 0;
    const bTime = b.scheduledPickupTime?.toDate ? b.scheduledPickupTime.toDate().getTime() : 0;
    return aTime - bTime;
  });

  return (
    <div className="max-w-[600px] mx-auto p-6">
      <div className="mb-4">
        <button onClick={() => navigate('/driver')} className="bg-transparent border-0 text-brand-primary font-semibold text-[0.9rem] cursor-pointer p-0">← Dashboard</button>
      </div>
      <h1 className="font-serif mt-0 mb-6 text-brand-dark">My Schedule</h1>

      <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}
        className="form-input mb-6" />

      {loading ? (
        <div className="p-10 text-center text-muted">Loading...</div>
      ) : todayBookings.length === 0 ? (
        <div className="p-10 text-center text-muted">No bookings for this date</div>
      ) : (
        <div className="relative pl-6">
          {/* Timeline line */}
          <div className="absolute left-2 top-0 bottom-0 w-0.5" style={{ background: '#e2e8f0' }} />

          {todayBookings.map((b, i) => {
            const time = b.scheduledPickupTime?.toDate ? new Date(b.scheduledPickupTime.toDate()) : null;
            const gap = i > 0 && todayBookings[i - 1].scheduledPickupTime?.toDate
              ? Math.round((time - new Date(todayBookings[i - 1].scheduledPickupTime.toDate())) / 60000 - (todayBookings[i - 1].estimatedDuration || 30))
              : null;

            return (
              <React.Fragment key={b.id}>
                {gap !== null && (
                  <div className="py-2 pl-6 text-[0.8rem] font-semibold" style={{ color: gap < 15 ? '#ff6b6b' : gap < 30 ? '#fbbf24' : '#2dd4a8' }}>
                    {gap < 0 ? '⚠️ Overlap!' : `${gap} min gap`}
                  </div>
                )}
                <div className="relative mb-4 pl-6">
                  <div className="absolute left-0.5 top-4 w-3.5 h-3.5 rounded-full" style={{
                    background: '#2dd4a8', border: '3px solid #fff', boxShadow: '0 0 0 2px #2dd4a8',
                  }} />
                  <div className="p-4 rounded-2xl border border-slate-200 bg-white">
                    <div className="flex justify-between mb-2">
                      <span className="font-bold text-brand-dark">{time ? time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}</span>
                      <span className="font-bold text-brand-primary">${b.fareBreakdown?.totalFare?.toFixed(2) || '—'}</span>
                    </div>
                    <div className="text-[0.85rem] text-body">
                      {b.pickupAddress || 'Pickup'} → {b.destinationAddress || 'Destination'}
                    </div>
                    <div className="text-[0.8rem] text-muted mt-1">
                      {b.referenceNumber} · {b.passengerCount} pax · ~{b.estimatedDuration || '?'}min
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      )}
      <BackButtonBottom to="/driver" label="Dashboard" />
    </div>
  );
}